document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("product-modal-dialog")) {
    customElements.define(
      "product-modal-dialog",
      class ProductModalDialog extends customElements.get("modal-dialog") {
        constructor() {
          super();
          this.closeSubscriptionButton =
            this.querySelector(`[data-close-modal]`);
          this.closeSubscriptionButton.addEventListener("click", () => {
            this.hide();
            this.selectSubscription();
          });
          this.subscriptionVariantSelects =
            this.querySelector(
              `[data-close-modal]`
            ).dataset.subscriptionVaraintId;
        }
        connectedCallback() {
          super.connectedCallback();
        }

        show(opener) {
          super.show(opener);
        }
        hide() {
          super.hide();
        }
        selectSubscription() {
          const subscribeVariant = document.querySelector(`.frequency-box[data-variant-id="${this.subscriptionVariantSelects}"]`);
          if (!subscribeVariant) {
            return;
          }
          const variantWrap = subscribeVariant.closest('.variant-wrap');
          if (!variantWrap) {
            return;
          }
          const radioInput = variantWrap.querySelector('input[type="radio"]');
          if (!radioInput) {
            return;
          }
          radioInput.click();
        }
      }
    );
  }
});
